import { ActionType, ProColumns } from "@ant-design/pro-components";
import { DatePicker, Form } from "antd";
import BoxContainer from "base/ui/components/BoxContainer";
import CustomButton from "base/ui/components/Button";
import CustomSelect from "base/ui/components/CustomSelect";
import CustomProTable from "base/ui/components/CustomTable";
import * as Icon from 'base/ui/components/Icons';
import { Filter } from "base/ui/components/Icons";
import dayjs from "dayjs";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react";
import PageWrapper from "pages/Components/PageWrapper";
import { SearchBox, SearchForm, SearchItem } from "pages/Components/SearchBox";
import { SearchModel } from "pages/model";
import { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { CommonModel } from "services/Main/common_services";
import { ReportUnsatifiedModel } from 'services/Main/reportVisitCustomerSR';
import {
  commonPresenter,
  commonStore,
  reportVisitCustomerSRPresenter,
  reportVisitCustomerSRStore
} from "stores/root_store";
import { DATE_FORMAT_POST, PAGE_SIZE_DEFAULT, VARIABLE_CHECK_ZALO } from "utils/constants";
import { formatNumber } from 'utils/formatHelper';
import { getsaleOrg } from 'utils/localStorageHelper';
import { useCheckPermission } from "utils/permissionHelper";

const { RangePicker } = DatePicker;

// BÁO CÁO TỶ LỆ ĐÁNH GIÁ KHÔNG HÀI LÒNG CỦA KHÁCH HÀNG GHÉ THĂM SR
export function createPageRatioReviewUnsatisfied() {
  return observer(() => {
    useCheckPermission("INDEX");
    // ============ Navigation =================/
    const { t } = useTranslation();

    const [form] = Form.useForm();
    const tableRef = useRef<ActionType>();
    // const disablefield = useWatch('radioGroup', form)
    // Tìm kiếm / phân trang
    const [dataSearch, setDataSearch] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
      env: VARIABLE_CHECK_ZALO,
      isShowroom: true
    });
    // data table mẫu khảo sát
    const [dataTable, setDataTable] = useState<Record<string, any>[]>([]);
    // data common date
    const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);
    // loading khi xuất Excel
    const [exportLoading, setExportLoading] = useState(false);



    const initialColumn: ProColumns<Record<string, any>>[] = [
      {
        title: <Trans i18nKey={'zalo-notification.stt'} />,
        dataIndex: "stt",
        key: "stt",
        align: "center",
        width: 50,
      },
      // Mã khảo sát
      {
        title: 'Showroom',
        dataIndex: "storeName",
        key: "storeName",
        render: (_, record) => {
          return <div>
            {record?.storeName}
          </div>
        }
      },
      // Tổng lượt đánh giá
      {
        title: t('project-report.report-visit-customer.total-rate'),
        dataIndex: 'luotDanhGia',
        key: 'luotDanhGia',
        render: (_, record) => {
          return <div>{formatNumber(record.luotDanhGia, 0)}</div>
        },
        onCell: () => ({ style: { textAlign: 'right' } })
      },
    ];

    const [columns, setColumns] = useState<ProColumns<Record<string, any>>[]>(
      initialColumn
    );
    // disable rangePicker khi chọn ngày từ common
    const [disableRangePicker, setDisableRangePicker] = useState(false);

    // LẤY DANH SÁCH COMMON DATE -----------------------------------------------------------------------
    const getListCommonDate = async () => {
      await commonPresenter.getListSelectCommonDate(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCommonDate(commonStore.commonRespone.data);
      }
    };

    // LẤY NGÀY BẰNG COMMON DATA -----------------------------------------------------------------------
    /*
      hàm set tùy chỉnh ngày tháng, nếu chọn tùy chỉnh thì cho chọn ngày
      còn không thì sẽ lấy data từ api để set vào from date to date
    */
    const getDateByKey = async (key: string) => {
      await commonPresenter.getDateByCommonDate(commonStore, key);
      if (commonStore.commonDate.fromDate) {

        // set value ban đầu chp biến để search báo cáo (ngày tháng)
        setDataSearch({
          ...dataSearch,
          fromTime: commonStore.commonDate.fromDate ? dayjs(commonStore.commonDate.fromDate)?.format(DATE_FORMAT_POST) : undefined,
          toTime: commonStore.commonDate.toDate ? dayjs(commonStore.commonDate.toDate)?.format(DATE_FORMAT_POST) : undefined,
          companyId: form.getFieldValue('companyId'),
        });

        form.setFieldValue("ngayDanhGia", [
          dayjs(commonStore.commonDate.fromDate),
          dayjs(commonStore.commonDate.toDate),
        ]);
      } else {
        form.setFieldValue("ngayDanhGia", undefined);
      }
    };

    useEffect(() => {
      getListCommonDate();
    }, []);

    // ===============================SEARCH BOX ==============================================================
    const [open, setOpen] = useState(false);
    const showDrawer = () => {
      setOpen(true);
    };

    const onClose = () => {
      setOpen(false);
    };



    // lấy data báo cáo =============================================================================
    const getDataReport = async (dataSearch: object) => {
      await reportVisitCustomerSRPresenter.getDataReportUnsatified(reportVisitCustomerSRStore, dataSearch);
      if (reportVisitCustomerSRStore.reportUnsatified.isSuccess) {
        const dataTemp = cloneDeep(reportVisitCustomerSRStore.reportUnsatified.data);
        setDataTable(dataTemp);
        return dataTemp;
      }
      setDataTable([]);
      return [];
    }

    // Hàm lấy data danh sách công ty =================================================================
    // const [listCreateBy, setListCreateBy] = useState<CommonModel[]>([]);
    // công ty
    const [listSaleOrg, setListSaleOrg] = useState<CommonModel[]>([]);

    const getListSaleOrg = async () => {
      await commonPresenter.getListSaleOrg(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListSaleOrg(commonStore.commonRespone.data);
      }
    };

    // Lấy  danh sách người tạo
    // const getListCreateBy = async (key = '') => {
    //   await commonPresenter.getListPersonInCharge(commonStore, key);
    //   if (commonStore.commonRespone.isSuccess) {
    //     setListCreateBy(commonStore.commonRespone.data);
    //   }
    // };
    // const searchCreateBy = useDebounce(getListCreateBy, 500);



    // Hàm lấy data danh sách công ty =================================================================
    const [listBranch, setListBranch] = useState<CommonModel[]>()


    // chi nhánh
    const getListBranch = async (company: string) => {
      await commonPresenter.getBranchByCompany(commonStore, company)
      setListBranch(commonStore.commonRespone.data)
    };

    // Lấy công ty cụ thể theo saleOrg
    const getCompanyBySaleOrg = async () => {
      await reportVisitCustomerSRPresenter.getCompanyBySaleOrg(reportVisitCustomerSRStore, getsaleOrg());

      if (reportVisitCustomerSRStore.companyBySaleOrg.data) {
        form.setFieldValue('companyId', reportVisitCustomerSRStore.companyBySaleOrg.data)

        setDataSearch({
          ...dataSearch,
          companyId: reportVisitCustomerSRStore.companyBySaleOrg.data
        });
      }
    }



    useEffect(() => {
      (async () => {
        getListSaleOrg();
        // getListCreateBy();
        await getListCommonDate()
        // set value ban đầu
        form.setFieldValue('commonDate', 'LastMonth')
        await getCompanyBySaleOrg();
        await getDateByKey('LastMonth')
        await getListBranch(form.getFieldValue('companyId'))
        // hàm set tháng trước cho
        handleChangeColumn(commonStore.commonDate.fromDate, commonStore.commonDate.toDate)
        setDisableRangePicker(true)


        tableRef.current?.reload();
      })()
    }, [])


    const handleChangeColumn = (day1: string, day2: string) => {
      // lấy khoảng tháng từ field search được và list ra mảng các tháng trong khoảng đó để render
      const x = [Number(dayjs(day1).format('MM')), Number(dayjs(day2).format('MM'))];
      const newArr = Array.from({ length: x[1] - x[0] + 1 }, (_, index) => index + x[0]);
      const dataColumn: ProColumns<Record<string, any>>[] = newArr.map(
        (item) => ({
          title: `Tháng ${item}`,
          key: item,
          dataIndex: item,
          align: "center",
          children: [
            {
              title: `Tiêu cực`,
              key: `tieuCuc${item}`,
              dataIndex: `tieuCuc${item}`,
              align: "right",
            },
            {
              title: `Tỷ lệ`,
              key: `tiLe${item}`,
              dataIndex: `tiLe${item}`,
              align: "right",
              render: (_, record) => {
                return <div>{_}%</div>
              }
            },
          ]
        })
      );

      const columnTemp = cloneDeep(initialColumn);
      columnTemp.splice(3, 0, ...dataColumn);
      setColumns(columnTemp)

    }


    return (
      <PageWrapper
        breadcrumb={[
          {
            text: "Báo cáo tỷ lệ đánh giá không hài lòng của khách hàng ghé thăm SR",
          },
        ]}
        extras={
          <>
            <CustomButton
              onClick={showDrawer}
              type="primary"
              color="#EFF4F9"
              className="!px-0 w-8"
            >
              <Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        <BoxContainer>
          <CustomProTable<Record<string, any>>
            options={false}
            handleResize={() => { }}
            bordered
            dataSource={dataTable}
            columns={columns}
            actionRef={tableRef}
            request={async (params = {}, sort, filter) => {
              let data: ReportUnsatifiedModel[] = [];
              if (dataSearch.fromTime && dataSearch.fromTime) {
                data = await getDataReport(dataSearch);
              }
              return {
                data: data,
                success: reportVisitCustomerSRStore.reportUnsatified.isSuccess,
              };
            }}

            toolBarRender={() => [
              // EXPORT =================================================================
              <CustomButton
                loading={exportLoading}
                onClick={async () => {
                  setExportLoading(true);

                  const { paging, ...rest } = dataSearch
                  await reportVisitCustomerSRPresenter.exportExcelBC5({ ...rest, env: VARIABLE_CHECK_ZALO, })
                  setExportLoading(false);
                }}
                icon={<Icon.Download className={'!fill-dark'} />}
              >
                {t('btn.export')}
              </CustomButton>]}

            scroll={{ x: columns.length > 8 ? 1900 : 1400 }}
            pagination={false}
            rowKey="STT"
          />
        </BoxContainer>

        <SearchBox
          onClose={onClose}
          open={open}
          className="lg:!w-[50%]"
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              type="primary"
              onClick={() => {

                form.submit();
              }}
            >
              {t("btn.search")}
            </CustomButton>
          }
        >
          <SearchForm
            form={form}
            onFinish={(value) => {
              const ngayDanhGia = value["ngayDanhGia"];
              let fromTime = undefined;
              let toTime = undefined;
              if (ngayDanhGia) {
                fromTime = ngayDanhGia[0].format("YYYY-MM-DD") || undefined;
                toTime = ngayDanhGia[1].format("YYYY-MM-DD") || undefined;
                handleChangeColumn(fromTime, toTime)

              }
              setDataSearch({
                ...value,
                paging: { ...dataSearch.paging, pageIndex: 1 },
                isShowroom: true,
                fromTime: fromTime,
                toTime: toTime,
                env: VARIABLE_CHECK_ZALO
              });

              tableRef.current?.reload();
            }}

            initialValues={{
              radioGroup: 2
            }}
          >

            {/* Công ty */}
            <SearchItem name={'companyId'} label={'Công ty'} col2>
              <CustomSelect
                options={listSaleOrg}
                fieldNames={{ label: "value", value: "key" }}
                allowClear
                showSearch
                onChange={async (value, option) => {
                  await getListBranch(value)
                }}
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            </SearchItem>


            {/* <SearchItem name={'radioGroup'} label="Đối tượng đánh giá">
              <Radio.Group onChange={(e) => {
                if (e.target.value === 1) {
                  form.setFieldValue('storeId', [])
                } else {
                  form.setFieldValue('employee', [])
                }
              }}>
                <Radio value={1}>Theo nhân viên tiếp khách</Radio>
                <Radio value={2}>Theo showroom</Radio>
              </Radio.Group>
            </SearchItem> */}


            {/* showroom */}
            <SearchItem name={'storeId'} label={'Showroom'} col2>
              <CustomSelect
                // disabled={disablefield === 1 || !disablefield}
                options={listBranch}
                fieldNames={{ label: "value", value: "key" }}
                allowClear
                showSearch
                mode='multiple'
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            </SearchItem>
            {/* user được đánh giá (danh sách tất cả các nhân viên) */}
            {/* <SearchItem name={'employee'} label={'User được đánh giá'} col2>
              <CustomSelect
                // disabled={disablefield === 2 || !disablefield}
                options={listCreateBy}
                mode='multiple'
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={false}
                onSearch={(value) => {
                  searchCreateBy(value);
                }}
                allowClear
                showSearch
              />
            </SearchItem> */}



            {/* Ngày đánh giá  */}
            <SearchItem name={"commonDate"} label={"Thời gian"} start col2>
              <CustomSelect
                options={listCommonDate}
                fieldNames={{ label: "value", value: "key" }}
                onChange={async (value, option) => {
                  if (option) {
                    setDisableRangePicker(
                      option.key === "Custom" ? false : true
                    );
                    await getDateByKey(option.key);
                  } else {
                    setDisableRangePicker(false);
                    form.setFieldValue("ngayDanhGia", undefined);
                  }
                }}
                allowClear
              />
            </SearchItem>
            {/* chọn ngày*/}
            <SearchItem name={"ngayDanhGia"} col2>
              <RangePicker
                disabled={disableRangePicker}
                format="DD/MM/YYYY"
                className="w-full"
              />
            </SearchItem>
          </SearchForm>
        </SearchBox>
      </PageWrapper>
    );
  });
}
